import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Page } from 'components/core/Page';

import { withExperiment } from '@sparefoot/react-core/decorators';
import useSearchHandler from 'hooks/useSearchHandler';
import usePageViewTracking from 'hooks/usePageViewTracking';
import { WhySSDC } from 'components/plp/WhySSDC/WhySSDC';
import { TrustPilotReviewSection } from 'components/landing/TrustPilotReviewSectionV2';
import { PAGE_TYPES } from '@sparefoot/tracking-events';

import { getCanonicalStorageType, PPC_TYPE_STORAGE } from 'config/constants';
import { toTitleCase } from 'utils/formatting';

import PSPLayout from 'components/psp/PSPLayout/PSPLayout';

import HowItWorksSection from 'components/plp/HowItWorks/HowItWorksSection';
import { PLPBottom } from 'components/plp/PLPBottom/PLPBottom';
import { PLPFooter } from 'components/plp/PLPFooter/PLPFooter';
import './PaidLandingPage.scss';

export function PaidLandingPage() {
	usePageViewTracking(PAGE_TYPES.PPC);

	const storageType = useSelector((state) => state.pages.storageType);
	const metaTitle = useSelector((state) => state?.pages?.meta?.title);
	const metaDescription = useSelector(
		(state) => state?.pages?.meta?.description,
	);
	const pageType = useMemo(() => toTitleCase(storageType), [storageType]);

	const canonicalType = getCanonicalStorageType(storageType);
	const additionalSearchParams = useMemo(() => {
		if (canonicalType !== PPC_TYPE_STORAGE) {
			return { type: 'vehicle', vehicle: canonicalType };
		}
		return {};
	}, [canonicalType]);
	const searchType =
		canonicalType === PPC_TYPE_STORAGE ? 'storage' : 'vehicle';

	const handleSearch = useSearchHandler({
		additionalSearchParams,
		type: searchType,
	});

	return (
		<Page
			title={metaTitle}
			description={metaDescription}
			marketingPage
			trackingPixel=""
		>
			<PSPLayout
				storageType={pageType}
				handleSearch={handleSearch}
			/>
			<HowItWorksSection />
			<TrustPilotReviewSection />
			<WhySSDC />
			<PLPBottom
				storageType={pageType}
				handleSearch={handleSearch}
			/>
			<PLPFooter />
		</Page>
	);
}

export default withExperiment('sf_15731_plp_refactor_ssdc')(PaidLandingPage);
